import moment from "moment";

// Dati della convocazione da mandare alle famiglie: ritrovo, divisa, staff, note.
// Restano nel browser finché la gara non ha i suoi campi sul server
// (contratto in docs/ARCHITECTURE.md → "Aperti team manager").

const STORAGE_KEY = "convocation_info_v1";
export const MEETING_BEFORE_MINUTES = 90;

const readStore = () => {
	try {
		return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
	} catch {
		return {};
	}
};

const writeStore = (store) => {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
	} catch {
		// senza memoria del browser i dati valgono solo per questa stampa
	}
};

export const convocationDefaults = (match, side, last = {}) => ({
	meetingAt:
		match?.startDate && !match.startTimeToBeConfirmed
			? moment(match.startDate)
					.subtract(MEETING_BEFORE_MINUTES, "minutes")
					.toDate()
			: null,
	meetingPlace: side === "home" ? match?.fieldName || "" : "",
	kit: last.kit || "",
	notes: "",
	staffIds: last.staffIds || [],
});

// Divisa e staff si ripropongono dall'ultima convocazione della stessa rosa
export const loadConvocationInfo = (match, side, rosterId) => {
	const store = readStore();
	const saved = store.matches?.[match?.id + "_" + side];
	const defaults = convocationDefaults(
		match,
		side,
		(rosterId && store.rosters?.[rosterId]) || {},
	);
	if (!saved) return defaults;
	return {
		...defaults,
		...saved,
		meetingAt: saved.meetingAt ? new Date(saved.meetingAt) : null,
		staffIds: saved.staffIds || [],
	};
};

export const hasConvocationInfo = (match, side) =>
	!!readStore().matches?.[match?.id + "_" + side];

export const saveConvocationInfo = (match, side, rosterId, info) => {
	const store = readStore();
	writeStore({
		matches: {
			...store.matches,
			[match.id + "_" + side]: {
				...info,
				meetingAt: info.meetingAt ? moment(info.meetingAt).toISOString() : null,
			},
		},
		rosters: rosterId
			? {
					...store.rosters,
					[rosterId]: {kit: info.kit, staffIds: info.staffIds},
				}
			: store.rosters,
	});
};

export const matchTitle = (match) =>
	`${match?.homeTeamName || match?.homeClub || "Casa"} – ${
		match?.awayTeamName || match?.awayClub || "Ospiti"
	}`;

export const kickOffLabel = (match) =>
	!match?.startDate
		? "Da definire"
		: match.startTimeToBeConfirmed
			? "Orario da definire"
			: moment(match.startDate).format("HH:mm");

export const matchCompetition = (match) =>
	match?.competitionSeason?.competition?.name ||
	match?.competitionName ||
	match?.playersCategory ||
	"";

export const convocationPlayer = (p) => ({
	name:
		`${p.lastName || ""} ${p.firstName || ""}`.trim() ||
		p.playerName ||
		"Nome non disponibile",
	role: p.goalkeeper ? "Portiere" : p.primaryRole || "",
	year: p.dateOfBirth
		? moment(p.dateOfBirth).format("YYYY")
		: p.playerYear || "",
});

export const staffMember = (s) => ({
	id: s.staffId || s.staff?.id,
	name: `${s.staff?.lastName || ""} ${s.staff?.firstName || ""}`.trim(),
	role:
		s.role ||
		(typeof s.staff?.role === "string" ? s.staff.role : s.staff?.role?.name) ||
		"",
});

// Testo da incollare nel gruppo delle famiglie (grassetto di WhatsApp con *)
export const convocationMessage = ({match, teamName, info, players, staff}) => {
	const day = match?.startDate
		? moment(match.startDate).format("dddd D MMMM")
		: "";
	const lines = [
		teamName ? `*Convocazione ${teamName}*` : "*Convocazione*",
		matchTitle(match),
		[
			day && day[0].toUpperCase() + day.slice(1),
			match?.startDate &&
				(match.startTimeToBeConfirmed
					? "orario da definire"
					: "calcio d'inizio " + kickOffLabel(match)),
		]
			.filter(Boolean)
			.join(", "),
	];
	if (info.meetingAt || info.meetingPlace)
		lines.push(
			"Ritrovo: " +
				[
					info.meetingAt && moment(info.meetingAt).format("HH:mm"),
					info.meetingPlace,
				]
					.filter(Boolean)
					.join(" · "),
		);
	if (match?.fieldName && match.fieldName !== info.meetingPlace)
		lines.push("Campo: " + match.fieldName);
	if (info.kit) lines.push("Divisa: " + info.kit);
	lines.push(
		"",
		`*Convocati (${players.length})*`,
		...players.map((p) => p.name),
	);
	if (staff.length)
		lines.push(
			"",
			"*Staff*",
			...staff.map((s) => (s.role ? `${s.name} (${s.role})` : s.name)),
		);
	if (info.notes) lines.push("", info.notes);
	return lines.join("\n");
};
